import React, {useEffect, useState} from "react";
import {createZone, fetchZones, removeZone, updateZone} from "../api/api";
import {useApp} from "../Contex";
import BottomSheet from "../components/BottomSheet";
import CreatableSelect from "react-select/creatable";

const baseZone =()=> {
    return {
        zone: "0000",
        text: "",
        fbord: "",
        tbord: "",
        abord: []
    }
}

export default function Zones(){
    const { refresh, permissions: { write } } = useApp();
    const [zones, setZones] = useState([])
    const [edit, setEdit] = useState(null);
    const [add, setAdd] = useState(null);

    const fetchData = () => {
        fetchZones().then(({zones}) => {
            setZones(zones)
        })
    }
    useEffect(() => {
        fetchData()
    }, [refresh]);


    const ZoneModal = ({setOpen, open, onSave, header = "Redigera zon"}) => {
        const [item, setItem] = useState(baseZone())
        useEffect(() => {
            if(open){
                setItem({...baseZone(), ...open});
            }
            else{
                setItem(baseZone())
            }
        }, [open]);

        const [changed, setChanged] = useState(false)
        return (
            <BottomSheet show={open} setShow={setOpen}>
                <h3>{header}</h3>
                <div className="mb-4">
                    <label>Namn</label>
                    <input className="form-control w-auto"
                        value={item.text} onChange={(e)=>{
                            setItem(prevState => ({...prevState,text: e.target.value}))
                            setChanged(true)
                        }}/>
                </div>
                <hr/>
                <div>
                    <label>Från</label>
                    <input className="form-control w-auto mb-2"
                           value={parseInt(item.fbord) ?? 0}
                           type="number"
                           onChange={(e)=>{
                               setItem(prevState => ({...prevState, fbord: (e.target.value).toString()??"0"}))
                               setChanged(true)
                           }}/>
                    <label>Till</label>
                    <input className="form-control w-auto"
                           value={parseInt(item.tbord) ?? 0}
                           type="number"
                           onChange={(e)=>{
                               setItem(prevState => ({...prevState, tbord: (e.target.value).toString()??"0"}))
                               setChanged(true)
                           }}
                    />
                </div>
                {item.abord && <>
                <hr/>
                <div>
                    <label>Extra bord:</label>
                    <CreatableSelect isMulti={true}
                                     value={item.abord.map((bord)=>({label:bord, value:bord}))}
                                     onCreateOption={(table)=>{
                                        const current = item.abord
                                        current.push(table)
                                        setItem(prevState => ({...prevState, abord: current}))
                                        setChanged(true)
                                    }}
                                     onChange={(tables) => {
                                         const current = (tables || []).map(bord => bord.label);
                                         setItem(prevState => ({ ...prevState, abord: current }));
                                         setChanged(true)
                                     }}

                    />
                </div>
                </>}
                {write &&
                <div className="mt-3 d-flex justify-content-between" style={{height: "38px"}}>
                    {!onSave &&
                    <button className="btn btn-outline-danger" onClick={()=>{
                        removeZone(item.zone).then((res)=>{
                            if(res.removed){
                                setOpen(null)
                                fetchData()
                            }
                        })
                    }}>
                        <i className="bi bi-trash"/>
                    </button>}
                        {(changed || onSave) &&
                            <button className="btn btn-success" onClick={()=>{
                                if(onSave)return onSave(item)
                                updateZone(item).then((res)=>{
                                    if(res.added){
                                        setOpen(null)
                                        fetchData()
                                    }
                                })
                            }}>
                                <i className="bi bi-save me-2"></i>Spara
                            </button>
                        }

                </div>
                }
            </BottomSheet>
        )
    }

    return(<>
            <div className="d-flex justify-content-between align-items-center p-2">
                <h1>Zoner</h1>
                {write && <button className="btn btn-secondary" onClick={()=>{setAdd(baseZone())}}>Skapa ny</button>}
            </div>
            {zones.map((zone) => (
                <div key={zone.zone} className="card mb-3 p-3 bg-light shadow-sm">
                    <div className="d-flex justify-content-between align-items-start">
                    <div>
                    <h5 className="mb-2 fw-bold">{zone.text}</h5>
                    <div>
                        {zone.fbord && zone.tbord && <div className="mb-1">
                            <span className="text-dark fw-semibold">Standard bord: </span>
                            <span className="text-muted">{parseInt(zone.fbord)} – {parseInt(zone.tbord)}</span>
                        </div>}
                        {Array.isArray(zone.abord) && zone.abord.length > 0 && (
                            <div>
                                <span className="text-dark fw-semibold">Extra: </span>
                                <span className="text-muted">{zone.abord.length} st</span>
                            </div>
                        )}
                    </div>
                    </div>
                        {write && (<div className="d-flex gap-2">
                            <button className="btn btn-outline-secondary" onClick={() => {
                                setEdit(zone)
                            }}>
                                <i className="bi bi-pencil-square"></i>
                            </button>
                            <button className="btn btn-outline-danger" onClick={()=>{
                                removeZone(zone.zone).then((res)=>{
                                    if(res.removed){
                                        fetchData()
                                    }
                                })
                            }}>
                                <i className="bi bi-trash"></i>
                            </button>

                        </div>)}
                    </div>
                </div>

            ))}
            <ZoneModal open={edit} setOpen={setEdit}/>
            <ZoneModal open={add} setOpen={setAdd} onSave={(zone)=>{
                createZone(zone).then((res)=>{
                    if(res.added){
                        setEdit(null)
                        setAdd(null)
                        fetchData()
                    }
                })
            }} header="Ny zon"/>
        </>
    )
}
